@if (!summonData) {
<span class="summon-value" [ngClass]="{'text-white' : !right, 'small' : action.small}">
  <span class="summon-label"><span [ghs-label]="(isSpawn ? 'game.action.spawn' : 'game.action.summon')"
      [style]="style"></span>&nbsp;</span>
  @for (spawn of monsters | trackUUID; track spawn._trackUUID; let i = $index) {
  @if (spawn.monster.type) {
  <span class="spawn" ghs-pointer-input (singleClick)="toggleHighlight($event)"
    [clickBehind]="!isInteractiveApplicableAction()" [ghs-tooltip]="'monster.toggleAction'" [delay]="1"
    [disabled]="!isInteractiveApplicableAction()"
    [ngClass]="{'action-interactive' : isInteractiveApplicableAction(), 'action-interactive-highlight': highlightAction()}">
    @if (spawn.monster.type != MonsterType.boss) {
    <span [ghs-label]="spawn.marker ? 'game.summon.spawnTypeMarker' : 'game.summon.spawnType'"
      [ghs-label-args]="[spawn.monster.name, spawn.monster.type, spawn.count ? spawn.count : '', spawn.marker]"
      [style]="style"></span>
    }
    @if (spawn.monster.type == MonsterType.boss) {
    <span [ghs-label]="spawn.marker ? 'game.summon.spawnMarker' : 'game.summon.spawn'"
      [ghs-label-args]="[spawn.monster.name, spawn.count ? spawn.count : '', spawn.marker]" [style]="style"></span>
    }
    @if (spawn.monster.health) {
    <span>
      (<span [value-calc]="spawn.monster.health"></span>&nbsp;<span [ghs-label]="'game.hp'"
        [style]="style"></span>)&nbsp;
    </span>
    }
    @if (i < monsters.length - 1 && monsters.length> 1) {
      <span>&nbsp;<span [ghs-label]="'and'" [style]="style"></span>&nbsp;</span>
      }
  </span>
  }
  }
  @for (spawn of objectives | trackUUID; track spawn._trackUUID; let i = $index) {
  <span class="spawn" ghs-pointer-input (singleClick)="toggleHighlight($event)"
    [clickBehind]="!isInteractiveApplicableAction()" [ghs-tooltip]="'monster.toggleAction'" [delay]="1"
    [disabled]="!isInteractiveApplicableAction()"
    [ngClass]="{'action-interactive' : isInteractiveApplicableAction(), 'action-interactive-highlight': highlightAction()}">
    <span [ghs-label]="spawn.marker ? 'game.summon.spawnObjectiveMarker' : 'game.summon.spawnObjective'"
      [ghs-label-args]="[spawn.objective.name, spawn.count ? spawn.count : '', spawn.marker]" [style]="style"></span>
    @if (i < objectives.length - 1 && objectives.length> 1) {
      <span>&nbsp;<span [ghs-label]="'and'" [style]="style"></span>&nbsp;</span>
      }
  </span>
  }
</span>
}

@if (!!summonData) {
<ghs-summon-sheet [summon]="getSummon()" [summonData]="summonData" [action]="true" [additional]="additional"
  [right]="right" [item]="action.value == 'summonDataItem'" [style]="style" [character]="character" [cardId]="cardId"
  [index]="actionIndex"></ghs-summon-sheet>
}